import { Bar } from 'react-chartjs-2';
import { useEffect, useRef, useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChartAbexa = ({ dataGrafico, titulo }) => {
    const containerRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const OpcionesGrafico = {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: isMobile ? 1.2 : 2.5,
        plugins: {
            legend: { 
                position: isMobile ? 'bottom' : 'top',
                labels: {
                    boxWidth: isMobile ? 12 : 15,
                    font: {
                        size: isMobile ? 10 : 12
                    }
                }
            },
            title: {
                display: true,
                text: titulo,
                color: '#fff',
                font: {
                    size: isMobile ? 14 : 16,
                    weight: 'bold'
                },
                padding: {
                    bottom: isMobile ? 10 : 20
                }
            },
        },
        scales: {
            x: {
                stacked: false,
                grid: { color: 'rgba(255, 255, 255, 0.1)' },
                ticks: {
                    font: {
                        size: isMobile ? 9 : 11
                    },
                    maxRotation: isMobile ? 45 : 0,
                    minRotation: isMobile ? 45 : 0
                }
            },
            y: {
                stacked: false,
                grid: { color: 'rgba(255, 255, 255, 0.1)' },
                ticks: {
                    font: {
                        size: isMobile ? 9 : 11
                    }
                }
            }
        }
    };

    return (
        <div
            ref={containerRef}
            style={{
                backgroundColor: '#1f2937',
                padding: isMobile ? '5px' : '8px',
                borderRadius: '8px',
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden'
            }}
        >
            <div style={{ width: '100%', height: 'auto' }}>
                <Bar options={OpcionesGrafico} data={dataGrafico} />
            </div>
        </div>
    );
};

export default BarChartAbexa;